import React from 'react';

const FinanceTooltipPanel = ({
  title,
  rows = [],
  totalText,
  emptyText = 'Sem dados para exibir.',
  footerNode = null,
}) => {
  const hasRows = rows.length > 0;

  return (
    <div className="bg-[color:var(--surface)] text-[color:var(--text-primary)] p-3 rounded-lg shadow-lg border border-[color:var(--border)]">
      <div className="font-semibold mb-3">{title}</div>

      <div className="space-y-2">
        {!hasRows && <p className="text-xs text-[color:var(--text-muted)]">{emptyText}</p>}
        {rows.map((row) => (
          <div key={row.id} className="flex items-center justify-between gap-3">
            <div className="inline-flex items-center gap-2 min-w-0">
              <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: row.dotColor }} />
              <span className="text-xs text-[color:var(--text-muted)]">{row.label}</span>
            </div>
            <span className={`text-xs font-semibold tabular-nums ${row.textClass || 'text-[color:var(--text-primary)]'}`}>
              {row.value}
            </span>
          </div>
        ))}
      </div>

      {totalText && (
        <div className="text-[color:var(--text-muted)] text-xs border-t border-[color:var(--border)] pt-2 mt-2">
          {totalText}
        </div>
      )}

      {footerNode}
    </div>
  );
};

export default FinanceTooltipPanel;
